/* BEGIN TFX_VARIANT_PICKER_HAS_FALLBACK
   Objective: prevent variant-picker crashes on browsers without :has() selector support in querySelectorAll.
   Scope: variant-picker custom element only.
   Notes:
   - Symmetry 8.1.1 uses :has() in updateSwatchLabel(). This is valid on modern Safari/Chrome, but can throw
     a SyntaxError on older Safari / embedded webviews and break variant UX.
   Rollback: delete this file + remove its <script> include block from layout/theme.liquid.
   Date: 2026-02-13
*/
(function () {
  'use strict';

  var FLAG = '__tfxVariantPickerHasFallbackInstalled';
  if (window[FLAG]) return;
  window[FLAG] = true;

  function supportsHasSelector() {
    try {
      document.querySelector(':has(*)');
      return true;
    } catch (e) {
      return false;
    }
  }

  // If :has() is supported, keep the theme's native implementation untouched.
  if (supportsHasSelector()) return;

  if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return;

  function patchVariantPicker() {
    var Ctor = window.customElements.get('variant-picker');
    if (!Ctor || !Ctor.prototype) return;

    var proto = Ctor.prototype;
    if (proto.__tfxHasFallbackPatched) return;
    proto.__tfxHasFallbackPatched = true;

    // Replace only the method using :has(), keep all other logic as-is.
    proto.updateSwatchLabel = function () {
      try {
        var optionSelectors = this.querySelectorAll('.option-selector');
        for (var i = 0; i < optionSelectors.length; i += 1) {
          var option = optionSelectors[i];
          var label = option.querySelector('.js-color-text');
          if (!label) continue;

          var input = option.querySelector('.js-option:checked, .js-option[aria-selected="true"]');
          label.textContent = input ? input.value : '';
        }
      } catch (e) {
        // Defensive: never block variant flow if DOM is unexpected.
      }
    };
  }

  window.customElements.whenDefined('variant-picker').then(patchVariantPicker).catch(function () {});
})();
/* END TFX_VARIANT_PICKER_HAS_FALLBACK */

